import Form from "./Form";
import FormStickyHeader from "../../components/FormStickyHeader";

const SupplierEdit: React.FC = () => {
  return (
    <div>
      <FormStickyHeader>Edit Supplier</FormStickyHeader>
      <Form />
    </div>
  );
};

export default SupplierEdit;
